module.exports = __webpack_public_path__ + "static/media/team-d.8214e3c0.svg";